import {
  SHOW_PUBLISH_QUOTE_DIALOG,
  CLOSE_PUBLISH_QUOTE_DIALOG,
  PUBLISH_QUOTE_REQUEST,
  PUBLISH_QUOTE_REQUEST_ERROR,
  PUBLISH_QUOTE_REQUEST_SUCCESS,
  USER_PUBLICATION_QUOTE_CONFIRMED,
  USER_PUBLISH_QUOTE_CONFIRM
} from './PublishQuoteDialog.actions'

const publishQuoteDialogState = {
  loading: false,
  publicationConfirmed: false,
  publishQuoteConfirm: false,
  quoteRequestPublishedSuccessfully: false,
  showPublishQuoteDialog: false,
  showPublishQuoteErrorModal: false
}

/**
 * The publishQuoteDialog's reducer.
 */
const publishQuoteDialogReducer = (state = publishQuoteDialogState, { type }) => {
  switch (type) {
    case CLOSE_PUBLISH_QUOTE_DIALOG: {
      return { ...state, showPublishQuoteDialog: false }
    }
    case SHOW_PUBLISH_QUOTE_DIALOG: {
      return { ...state, showPublishQuoteDialog: true }
    }
    case USER_PUBLISH_QUOTE_CONFIRM: {
      return { ...state, publishQuoteConfirm: true }
    }
    case USER_PUBLICATION_QUOTE_CONFIRMED: {
      return { ...state, publicationConfirmed: true }
    }
    case PUBLISH_QUOTE_REQUEST: {
      return { ...state, loading: true }
    }
    case PUBLISH_QUOTE_REQUEST_ERROR: {
      return { ...state, error: true, loading: false, showPublishQuoteDialog: false }
    }
    case PUBLISH_QUOTE_REQUEST_SUCCESS: {
      return { ...state, loading: false, quoteRequestPublishedSuccessfully: true }
    }
    default: {
      return state
    }
  }
}

export default publishQuoteDialogReducer
